import AdminTable from 'layouts/AdminTable';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import { useTranslation } from 'react-i18next';
import { FormLabel, RadioGroup } from '@material-ui/core';
import makeStyles from '@material-ui/styles/makeStyles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { useEffect, useState } from 'react';
import { get, post } from 'helpers/apiHelpers';
import { SelectInput } from 'components';
import Datetime from 'react-datetime';
import FormTextInputNoGrid from 'components/FormTextInput/FormTextInputNoGrid';
import LabeledRadio from 'components/LabeledRadio/LabeledRadio';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import FormControlStickyButton from 'components/FormControlStickyButton/FormControlStickyButton';
import { toast } from 'react-toastify';
import SimpleWysywig from 'components/FormTextInput/SimpleWysiwyg';
import classNames from 'classnames';

const useStyles = makeStyles({
  ...buttonsStyle,
  ...extendedFormsStyle,
  radio: {
    padding: '10px 16px',
  },
  checkbox: {
    margin: '-7px -12px',
  },
  title: {
    marginLeft: '15px',
  },
  formLabelMarginTop: {
    marginTop: '20px',
  },
  formLabelMarginLeft: {
    marginLeft: '15px',
  },
});

const CreateEmailForm = ({ history }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [zones, setZones] = useState([]);
  const [usersAmount, setUsersAmount] = useState(0);

  const [emailConfiguration, setEmailConfiguration] = useState({
    content: '',
    subject: '',
    processAt: new Date(),
    marketingTerms: 'gaveConsent',
    activeDiets: 'all',
    dayBagChecked: false,
    dayBagDate: null,
    bagZoneChecked: false,
    bagZone: {},
  });

  useEffect(() => {
    get('/zones', {
      pagination: false,
      properties: ['id', 'name'],
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(res => {
      // eslint-disable-next-line no-shadow -- FIXME
      const zones = res['hydra:member'].map(zone => ({
        value: zone.id,
        name: zone.name,
      }));
      setZones(zones);
    });
    // eslint-disable-next-line no-use-before-define -- FIXME
    getCurrentFiltersUsersAmount(emailConfiguration);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleChange = event => {
    const excludedFromUserAmountValidation = ['content', 'subject'];
    const { name, value } = event.target;
    const updatedEmailConfiguration = {
      ...emailConfiguration,
      [name]: value,
    };
    setEmailConfiguration(updatedEmailConfiguration);

    if (!excludedFromUserAmountValidation.includes(name)) {
      // eslint-disable-next-line no-use-before-define -- FIXME
      getCurrentFiltersUsersAmount(updatedEmailConfiguration);
    }
  };

  const handleCheckboxChange = event => {
    const { name, checked } = event.target;
    const updatedEmailConfiguration = {
      ...emailConfiguration,
      [name]: checked,
    };
    setEmailConfiguration(updatedEmailConfiguration);
    // eslint-disable-next-line no-use-before-define -- FIXME
    getCurrentFiltersUsersAmount(updatedEmailConfiguration);
  };

  const getCurrentFiltersUsersAmount = ({
    marketingTerms,
    activeDiets,
    dayBagChecked,
    dayBagDate,
    bagZoneChecked,
    bagZone,
  }) => {
    // eslint-disable-next-line no-console -- FIXME
    console.log('first');
    const data = {
      ...(dayBagChecked ? { bagDate: dayBagDate } : {}),
      ...(bagZoneChecked && bagZone?.value ? { bagZone: bagZone.value } : {}),
      // eslint-disable-next-line no-negated-condition -- FIXME
      ...(activeDiets !== 'all'
        ? { hasActiveDiets: activeDiets === 'withActiveDiets' }
        : {}),
      // eslint-disable-next-line no-negated-condition -- FIXME
      ...(marketingTerms !== 'all'
        ? { emailConsent: marketingTerms === 'gaveConsent' }
        : {}),
      type: 'mail',
    };

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('/client-count-query', data).then(res => {
      setUsersAmount(res);
    });
  };
  // eslint-disable-next-line no-console -- FIXME
  console.log(emailConfiguration.content.length);
  const validateForm = () =>
    emailConfiguration.content &&
    emailConfiguration.processAt &&
    emailConfiguration.subject.trim();

  const handleSubmit = () => {
    const {
      processAt,
      content,
      subject,
      marketingTerms,
      activeDiets,
      dayBagChecked,
      dayBagDate,
      bagZoneChecked,
      bagZone,
    } = emailConfiguration;

    const isValid = validateForm();
    if (!isValid || usersAmount === 0) {
      if (!isValid) {
        toast.error(t('email.fillAllFields'));
      }
      if (usersAmount === 0) {
        toast.error(t('email.userListCountZero'));
      }
      return;
    }

    const data = {
      processAt,
      content,
      subject,
      filters: {
        bagDate: dayBagChecked && dayBagDate,
        bagZone: bagZoneChecked && bagZone.value,
        // eslint-disable-next-line no-negated-condition -- FIXME
        ...(activeDiets !== 'all'
          ? { hasActiveDiets: activeDiets === 'withActiveDiets' }
          : {}),
        // eslint-disable-next-line no-negated-condition -- FIXME
        ...(marketingTerms !== 'all'
          ? { emailConsent: marketingTerms === 'gaveConsent' }
          : {}),
      },
    };

    post('/mass-mails', data)
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(history.push('/admin/mass-mails'))
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .catch(() => {
        toast.error(t('email.emailNotCreated'));
      });
  };

  return (
    <>
      <h2>{t('email.creatingEmail')}</h2>
      <AdminTable>
        <GridContainer>
          <GridItem md={6}>
            <p className={classes.title}>{t('email.emailTo')}</p>
            <FormLabel
              className={classNames(
                classes.labelHorizontal,
                classes.formLabelMarginTop,
                classes.formLabelMarginLeft
              )}
            >
              {t('email.marketingConsent')}
            </FormLabel>
            <GridItem md={12}>
              <RadioGroup
                name="marketingTerms"
                value={emailConfiguration.marketingTerms}
                onChange={handleChange}
              >
                <LabeledRadio
                  className={classes.radio}
                  label={t('email.all')}
                  value="all"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('email.gaveConsent')}
                  value="gaveConsent"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('email.didNotGaveConsent')}
                  value="didNotGaveConsent"
                />
              </RadioGroup>
            </GridItem>
            <FormLabel
              className={classNames(
                classes.labelHorizontal,
                classes.formLabelMarginTop,
                classes.formLabelMarginLeft
              )}
            >
              {t('email.dietActivity')}
            </FormLabel>
            <GridItem md={12}>
              <RadioGroup
                name="activeDiets"
                value={emailConfiguration.activeDiets}
                onChange={handleChange}
              >
                <LabeledRadio
                  className={classes.radio}
                  label={t('email.all')}
                  value="all"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('email.withActiveDiet')}
                  value="withActiveDiets"
                />
                <LabeledRadio
                  className={classes.radio}
                  label={t('email.withoutActiveDiet')}
                  value="withoutActiveDiets"
                />
              </RadioGroup>
            </GridItem>
            <FormLabel
              className={classNames(
                classes.labelHorizontal,
                classes.formLabelMarginTop,
                classes.formLabelMarginLeft
              )}
            >
              {t('email.bags')}
            </FormLabel>
            <GridItem md={12}>
              <LabeledCheckbox
                className={classes.checkbox}
                checked={emailConfiguration.dayBagChecked}
                onClick={handleCheckboxChange}
                label={t('email.withDayBag')}
                name="dayBagChecked"
              />
            </GridItem>
            {emailConfiguration.dayBagChecked && (
              <GridItem md={6}>
                <Datetime
                  timeFormat={false}
                  dateFormat="YYYY-MM-DD"
                  closeOnSelect={true}
                  value={emailConfiguration.dayBagDate}
                  onChange={e => {
                    setEmailConfiguration(prev => ({
                      ...prev,
                      dayBagDate: e.format('DD.MM.YYYY'),
                    }));
                    getCurrentFiltersUsersAmount({
                      ...emailConfiguration,
                      dayBagDate: e.format('DD.MM.YYYY'),
                    });
                  }}
                  inputProps={{
                    placeholder: t('email.setDate'),
                    readOnly: true,
                  }}
                />
              </GridItem>
            )}
            <GridItem md={12}>
              <LabeledCheckbox
                className={classes.checkbox}
                checked={emailConfiguration.bagZoneChecked}
                onClick={handleCheckboxChange}
                label={t('email.withBagZone')}
                name="bagZoneChecked"
              />
            </GridItem>
            {emailConfiguration.bagZoneChecked && (
              <GridItem md={6}>
                <SelectInput
                  options={zones}
                  value={emailConfiguration.bagZone}
                  mapBy="name"
                  trackBy="value"
                  classes={classes}
                  handleChange={(e, option) => {
                    setEmailConfiguration(prev => ({
                      ...prev,
                      bagZone: option,
                    }));
                    getCurrentFiltersUsersAmount({
                      ...emailConfiguration,
                      bagZone: option,
                    });
                  }}
                />
              </GridItem>
            )}

            <GridItem md={12}>
              <p className={classes.formLabelMarginTop}>
                {t('email.recCount')}: <b>{usersAmount}</b>
              </p>
            </GridItem>
          </GridItem>
          <GridItem md={6}>
            <span className={classes.formLabelMarginLeft}>
              {t('email.message')}
            </span>

            <GridItem md={12}>
              <FormLabel
                className={classNames(
                  classes.labelHorizontal,
                  classes.formLabelMarginTop
                )}
              >
                {t('email.deliveryDate')} *
              </FormLabel>
              <Datetime
                timeFormat={true}
                closeOnSelect={true}
                value={emailConfiguration.processAt}
                name="processAt"
                onChange={date => {
                  setEmailConfiguration(prev => ({
                    ...prev,
                    processAt: date,
                  }));
                }}
                isValidDate={day =>
                  day.isAfter(Datetime.moment().subtract(1, 'day'))
                }
                inputProps={{
                  placeholder: t('email.setDate'),
                  readOnly: true,
                }}
              />
            </GridItem>
            <GridItem md={12}>
              <FormLabel
                className={classNames(
                  classes.labelHorizontal,
                  classes.formLabelMarginTop
                )}
              >
                {t('email.subject')} *
              </FormLabel>
              <FormTextInputNoGrid
                label={t('email.subject')}
                classes={classes}
                name="subject"
                value={emailConfiguration.subject}
                handleChange={handleChange}
                rows={2}
                rowsMax={30}
                multiline={true}
              />
            </GridItem>
            <GridItem md={12}>
              <FormLabel
                className={classNames(
                  classes.labelHorizontal,
                  classes.formLabelMarginTop
                )}
              >
                {t('email.content')} *
              </FormLabel>
            </GridItem>
            <GridItem md={12}>
              <SimpleWysywig
                value={emailConfiguration.content}
                handleChange={e => {
                  setEmailConfiguration(prev => ({
                    ...prev,
                    content: e.target.value,
                  }));
                }}
                numberRows={5}
              />
            </GridItem>
          </GridItem>
        </GridContainer>
      </AdminTable>
      <FormControlStickyButton
        isFixedToBottom={true}
        classes={classes}
        discardText={t('email.cancel')}
        submitText={t('email.addEmail2')}
        cancelPath="/admin/mass-mails"
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default CreateEmailForm;
